const PPTXViewer = ({ link, documentLoaded, onLoad = () => null }) => {
  return (
    <div style={{ userSelect: 'none', position: 'relative' }}>
      <iframe
        title="document"
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${link}`}
        sandbox="allow-scripts allow-same-origin allow-pointer-lock allow-forms allow-top-navigation-by-user-activation" // Disables the popup button
        style={{
          height: '65vh',
          width: '100%',
          opacity: documentLoaded ? 1 : 0,
          border: 'none',
        }}
        onLoad={onLoad}
        onContextMenu={(e) => e.preventDefault()}
      />
      {documentLoaded && (
        <>
          <div
            style={{
              left: 0,
              bottom: 6,
              width: '30%',
              height: '22px',
              position: 'absolute',
              cursor: 'default',
              zIndex: 10,
              backgroundColor: '#444444',
              borderTop: '1px solid #555555',
            }}
          />
          <div
            style={{
              right: 0,
              bottom: 6,
              width: '30%',
              height: '22px',
              position: 'absolute',
              cursor: 'default',
              zIndex: 10,
              backgroundColor: '#444444',
              borderTop: '1px solid #555555',
            }}
          />
        </>
      )}
    </div>
  );
};

export default PPTXViewer;
